import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { Benefits_Enrollment_Changes_Request_ReportPayload } from "@oysterhr/schema"

export const GENERATE_ENROLMENTS_REPORT_MUTATION = gql`
  mutation BenefitsStaffGenerateEnrollmentsReport($providerId: ID!) {
    requestEnrollmentsChangesReport(input: { providerId: $providerId }) {
      errors
    }
  }
`

export const useGenerateEnrollmentsReport = (
  options: InjectedOptions<
    { requestEnrollmentsChangesReport: Benefits_Enrollment_Changes_Request_ReportPayload },
    { providerId: string }
  >,
) => useMutation(GENERATE_ENROLMENTS_REPORT_MUTATION, options)
